export const Degree = {
  Associate: "Associate",
  Bachelor: "Bachelor",
  Master: "Master",
  PHD: "PHD",
};
